module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-heart-77690e59ba8eba07a79e029d07ea50e6.svg";